import React from "react";

import { cn } from "@/utils/cn";

import Text, { type TextProps } from "./ui/text/text";

interface MarkupProps extends TextProps {
  ref?: React.Ref<any>;
}

/** Styles HTML markup returned by the API, such as in account bios and statuses. */
const Markup = (props: MarkupProps) => {
  const { className, ref, ...rest } = props;

  return (
    <Text
      ref={ref}
      {...rest}
      data-markup
      data-testid="markup"
      className={cn(
        "whitespace-pre-wrap",
        "[&_p]:mb-4 [&_p]:whitespace-pre-wrap [&_p:last-child]:mb-0",
        "[&_a]:text-primary-600 [&_a]:hover:underline dark:[&_a]:text-primary-400",
        "[&_em]:italic [&_strong]:font-bold",
        "[&_ol]:mb-4 [&_ol]:pl-10 [&_ul]:mb-4 [&_ul]:pl-10",
        "[&_ol]:list-outside [&_ol]:list-decimal [&_ul]:list-outside [&_ul]:list-disc",
        "[&_blockquote]:mb-4 [&_blockquote]:border-l-4 [&_blockquote]:border-solid [&_blockquote]:border-gray-400 [&_blockquote]:py-1 [&_blockquote]:pl-4 [&_blockquote]:text-gray-500 dark:[&_blockquote]:text-gray-400",
        "[&_code]:cursor-text [&_code]:font-mono [&_pre]:cursor-text [&_pre]:font-mono",
        "[&_p>code]:bg-gray-100 dark:[&_p>code]:bg-primary-800",
        "[&_pre]:bg-gray-100 dark:[&_pre]:bg-primary-800",
        "[&_p>code]:rounded-sm [&_p>code]:px-1 [&_p>code]:py-0.5",
        "[&_pre]:mb-4 [&_pre]:overflow-x-auto [&_pre]:rounded-md [&_pre]:px-3 [&_pre]:py-2 [&_pre]:leading-6 [&_pre]:break-all [&_pre:last-child]:mb-0",
        "[&_img.emojione]:m-0 [&_img.emojione]:h-5 [&_img.emojione]:w-5",
        "[&_img.emojione+img.emojione]:ml-0.5",
        "[&_img:not(.emojione)]:hidden",
        "[&.big-emoji_img.emojione]:inline [&.big-emoji_img.emojione]:h-9 [&.big-emoji_img.emojione]:w-9 [&.big-emoji_img.emojione]:p-1",
        "[&_.status-link]:text-primary-600 [&_.status-link]:hover:text-primary-800 [&_.status-link]:hover:underline dark:[&_.status-link]:text-primary-400 dark:[&_.status-link]:hover:text-primary-400",
        "[&_.invisible]:absolute [&_.invisible]:inline-block [&_.invisible]:h-0 [&_.invisible]:w-0 [&_.invisible]:leading-0 [&_.invisible]:text-[0]",
        "[&_.invisible_img]:m-0! [&_.invisible_img]:h-0! [&_.invisible_img]:w-0! [&_.invisible_img]:border-0! [&_.invisible_img]:p-0!",
        "[&_.invisible_svg]:m-0! [&_.invisible_svg]:h-0! [&_.invisible_svg]:w-0! [&_.invisible_svg]:border-0! [&_.invisible_svg]:p-0!",
        className,
      )}
    />
  );
};

export default Markup;
